import React from 'react';
import PropTypes from 'prop-types';


class Address extends React.Component {

  render() {
    const {address, ...rest} = this.props;
    if (!address){
      return null;
    }
    return (
      <div {...rest}>
        <div>{`${address.street || ''} ${address.number || ''}`}</div>
        <div>{`${address.zipCode || ''} ${address.city|| ''}`}</div>
        <div>{`${address.country|| ''}`}</div>
      </div>
    );
  }
}


const address = {
  street: PropTypes.string,
  number: PropTypes.string,
  zipCode: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
}

Address.propTypes = {
  address: PropTypes.exact(address).isRequired,
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/common/Address.js